import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useUiConfirmModalStore } from '@/store/ui'
import {
  EstadosAgendamientoEnumChoice,
  EstadosOrdenTrabajoEnumChoice,
  ModulosEnumChoice,
  gridSizeMdLg12,
  gridSizeMdLg6,
  // rejectOTByTecnicoSchema,
  rejectOTInstalacionByTecnicoSchema,
} from '@/shared';
import {
  useFetchMotivosRechazo,
  useUpdateAgendamiento,
  useUpdateOrdenTrabajo,
} from '@/shared/actions/erp';
import { RejectOTByTecnicoData } from '@/shared/actions/erp/tecnico/instalaciones/asignaciones.actions';
import {
  CustomAutocomplete,
  CustomTextArea,
  TabTextLabel,
} from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import {
  Agendamiento,
  AlertSeverityEnum,
  MotivoRechazoOrdenTrabajo,
  OrdenTrabajo,
} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { useEffect } from 'react';
import ImagesWithZoom from '@/shared/components/ui/Images/ImagesWithZoom';

export interface ConfirmRejectOTDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  ordenTrabajo?: Partial<OrdenTrabajo>;
}

type RechazoFormData = RejectOTByTecnicoData & {
  observacion_rechazo_tecnico: string;
};

export const SendByMotivoRechazoFromOT = {
  toPyl:"ENVIAR A RECOORDINAR",
  toVentas:"ENVIAR A GESTIÓN ASESOR"
}

const PreRejectedInstalacionAsigTecModal: React.FC<ConfirmRejectOTDialogProps> = ({
  //ordenTrabajo,
  open,
  setOpen,
  ordenTrabajo,
}) => {
  
  ///* global state
  const setAlert = useUiStore(s => s.setAlert);
    const setConfirmDialogIsOpen = useUiConfirmModalStore(
      (s) => s.setConfirmDialogIsOpen
    );


  ///* form -------------------
  const formRechazo = useForm<RechazoFormData>({
    resolver: yupResolver(rejectOTInstalacionByTecnicoSchema) as any,
    defaultValues: {
      estado_orden_trabajo: EstadosOrdenTrabajoEnumChoice.PRE_RECHAZADO,
    },
  });

  ///* fetch data
  const { data: motivosRechazoOT, isLoading: isLoadingMotivosRechazoOT } =
    useFetchMotivosRechazo({
      page_size: 100,
      modulo: ModulosEnumChoice.ORDEN_TRABAJO,
    });

  ///* mutations
  const updateOrdenTrabajo = useUpdateOrdenTrabajo<Partial<OrdenTrabajo>>({
    customSuccessMessage: 'Orden de trabajo actualizada correctamente',
  });
  const updateAgendamiento = useUpdateAgendamiento<Partial<Agendamiento>>({
    enableSuccessAlert: false,
  });

  const onSave = async (data: RechazoFormData) => {
    alert('onSave')
    console.log({rechazoform:data})
    updateOrdenTrabajo.mutateAsync({
      id: ordenTrabajo?.id_orden_trabajo!,
      data: {
        estado_orden_trabajo: EstadosOrdenTrabajoEnumChoice.EN_ESPERA,
      },
    });

    updateAgendamiento.mutateAsync({
      id: ordenTrabajo?.agendamiento_data?.id_agendamiento!,
      data: {
        estado_agendamiento: EstadosAgendamientoEnumChoice.PENDIENTE_RECORDINACION,
      },
    });

    setConfirmDialogIsOpen(false)
    setOpen(false)
    

  };

  useEffect(() => {
    if (ordenTrabajo) {
      formRechazo.reset({
        ...ordenTrabajo,
        observacion_rechazo_tecnico: ordenTrabajo.observaciones?.observacion_rechazo_tecnico || '',
        // observaciones: {
        //   ...ordenTrabajo.observaciones,
        //   observacion_rechazo_tecnico: ordenTrabajo.observaciones?.observacion_rechazo_tecnico || '',
        // },
      });
    }
  }, [ordenTrabajo]);

  return (
    <ScrollableDialogProps
      open={open}
      title="Orden de Trabajo Pre-Rechazada"
      cancelTextBtn="Cancelar"
      confirmTextBtn="Enviar a Planificación y Logística"
      confirmVariantBtn="outlined"
      // actions
      onClose={() => {
        setOpen(false);
        formRechazo.reset();
      }}
      onConfirm={() => {
        formRechazo.handleSubmit(onSave, (error) => {
          console.log({error})
          setAlert(
            true,
            'Todos los campos son requeridos para rechazar la orden de trabajo',
            AlertSeverityEnum.error
          );
        })();
      }}
      // content
      minWidth="42%"
      contentNode={
        <>
          <Grid container spacing={3}>
            {/* -------- text -------- */}
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Detalles enviados por la flota: <b>{ordenTrabajo?.flota_data?.nombre}</b>
              </Typography>
            </Grid>

            {/* -------- motivo rechazo -------- */}

              <CustomAutocomplete<MotivoRechazoOrdenTrabajo>
                label="Estado Informe"
                name="motivo_rechazo"
                disabled
                // options
                options={(motivosRechazoOT?.data?.data as any) || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={formRechazo.getValues().motivo_rechazo || ''}
                optionLabelForEdit={
                  formRechazo.getValues().motivo_rechazo || ''
                }
                isLoadingData={isLoadingMotivosRechazoOT}
                // validation
                control={formRechazo.control}
                error={formRechazo.formState.errors.motivo_rechazo}
                helperText={
                  formRechazo.formState.errors.motivo_rechazo?.message
                }
                size={gridSizeMdLg12}
              />

            {/* -------- descripcion rechazo -------- */}
              <CustomTextArea
                label="Observación Rechazo"
                name="observacion_rechazo_tecnico"
                control={formRechazo.control}
                defaultValue={ 
                  formRechazo.getValues('observacion_rechazo_tecnico') || ''
                }
                error={formRechazo.formState.errors.observacion_rechazo_tecnico}
                helperText={
                  formRechazo.formState.errors.observacion_rechazo_tecnico
                    ?.message
                }
                required={false}
                disabled
              />

            {/* -------- fotos -------- */}
            <Grid item xs={12}>
              <TabTextLabel
                text="Evidencias"
                pt="12px"
                pb="15px"
                pl="0"
                mt="0"
              />

              <Grid item xs={12} container spacing={3}>
                {
                  ordenTrabajo?.urls_fotos_rechazo_tecnico && ordenTrabajo?.urls_fotos_rechazo_tecnico?.length > 0?
                  ordenTrabajo.urls_fotos_rechazo_tecnico.map((item, index) => item.photoUrl && (
                    <Grid item {...gridSizeMdLg6} key={`evidence-${index}`}>
                      <ImagesWithZoom
                        src={item.photoUrl}
                        alt={`Foto Pre-rechazo ${index + 1}`}
                      />
                    </Grid>
                  ))
                  :null 
                }
              </Grid>
            </Grid>
          </Grid>
        </>
      }
    />
  );
};

export default PreRejectedInstalacionAsigTecModal;
